import React, { useEffect, useState, useRef } from 'react';
import resourcesServices from '../services/resourcesServices';
import { errorMessage } from '../errorHandler';
import UseProgressiveImage from './multimedia/UseProgressiveImage';
import QRCode from 'react-qr-code';

const MultimediaPublicoImageBG = () => {

  const [images, setImages] = useState([]);
  const [indiceImagen, setIndiceImagen] = useState(0);
  const [indicePedido, setIndicePedido] = useState(0);
  const [running, setRunning] = useState(false);
  const [esTest, setEsTest] = useState(false);
  const [randomBG, setRandomBG] = useState(0);

  const backgroundImageSrc = ['image-src-1', 'image-src-2', 'image-src-3', 'image-src-4']
  const [pedidos, setPedidos] = useState([]);

  const [qrValue, setQrValue] = useState('https://wa.me/5492995368458?text=Hola.%20Quiero%20participar')

  const closeRef = useRef(null);

  // Animacion de imagenes
  useEffect(() => {
    // console.log("entro")
    const cambiarImagen = () => {
      setIndiceImagen((prev) => (prev + 1) % images.length);
    };

    if(running){
      const intervalo = setInterval(cambiarImagen, 6*1000);
      return () => clearInterval(intervalo);
    }
  }, [images]);

  // useEffect(() => {
  //     console.log(images.length, indiceImagen, images[indiceImagen] && images[indiceImagen]["id"], images[indiceImagen] && images[indiceImagen]["originalUrl"] )
  // }, [indiceImagen]);

  // Carga de nuevas imagenes cada 1 minuto
  useEffect(() => {
    const cargaImagenes = () => {
      const idsVar = images.map(v => v["id"]).join(",")

      obtenerMensajes(`ids=${idsVar}`)
    };

    if(running){
      const intervalo = setInterval(cargaImagenes, 60*1000);
      return () => clearInterval(intervalo);
    }

  }, [images]);

  // // Busqueda de nuevos pedidos
  // useEffect(() => {
  //   const buscarPedidos = () => {
  //     obtenerPedidosAprobados()
  //   };

  //   if(running){
  //     const intervalo = setInterval(buscarPedidos, 180*1000);
  //     return () => clearInterval(intervalo);
  //   }

  // }, [pedidos]);

  // // Animacion de pedidos
  // useEffect(() => {
  //   const cambiarPedido = () => {
  //     setIndicePedido((prev) => (prev + 1) % pedidos.length);
  //   };

  //   if(running){
  //     const intervalo = setInterval(cambiarPedido, 8*1000);
  //     return () => clearInterval(intervalo);
  //   }
  // }, [pedidos]);

  useEffect(() => {
    const randomImagen = Math.floor(Math.random() * 4);
    setRandomBG(randomImagen);

  }, []);

  useEffect(() => {
    if(esTest){
      obtenerMensajes()
      // obtenerPedidosAprobados()
      setRunning(true)
    }

  }, [esTest]);

  const comenzar = async () => {
    await obtenerMensajes()
    // await obtenerPedidosAprobados()
    setRunning(true)
  }

  const cerrarModal = () => {
    closeRef.current.click();
  }

  const obtenerMensajes = async (otro = 'ids=') => {
    try {
        const data = await resourcesServices.obtenerResources(`multimedia_usuarios/multimediaPublico`, '', '', 1, otro + `${esTest ? '&test=true' : ''}`);

      if(data.data.length > 0){
        setImages(images.concat(data.data));
      }
    } catch (error) {
      errorMessage(error)
    }
  };

  const obtenerPedidosAprobados = async () => {
    try {
      const data = await resourcesServices.obtenerResources(`musica_pedidos/todos`, '', '', 1, `${esTest ? '&test=true' : ''}`);
      // console.log(data.data.map(p => `${p.genero} - ${p.cancion}`))
      setPedidos(data.data.map(p => `${p.genero} - ${p.cancion}`))
    } catch (error) {
      errorMessage(error)
    }
  };


  return (
    <div className={`image-bg ${backgroundImageSrc[randomBG]}`}>
      <div className='content'>
        {
          running && images[indiceImagen] ? (
            <>
              {
                images[indiceImagen]['originalUrl'] && (
                  <div className='only-image'>
                    {
                    images[indiceImagen]['nombre_usuario'].length>0 && (
                      <>
                      <span className='text'>{images[indiceImagen]['nombre_usuario']}</span>
                      {
                        qrValue && (
                          <span className='qr'>
                            <QRCode
                              title="Patagonia Interactiva"
                              value={qrValue}
                              bgColor={'#FFFFFF'}
                              fgColor={'#000000'}
                              style={{ height: "auto", maxWidth: "100%", width: "100%" }}
                              size={256}
                            />
                          </span>
                        )
                      }
                      </>
                    )
                    }
                    <UseProgressiveImage src={images[indiceImagen]['originalUrl']} ></UseProgressiveImage>
                  </div>
                )
              }
            </>
          ) : (
            <div className='main-message d-flex align-items-center text-center justify-content-center' style={{height:'100vh'}}>
              <button data-bs-toggle="modal" data-bs-target="#videoSourceModal" className='btn btn-primary ms-3' type='button'>Origen de las imágenes</button>
            </div>
          )
        }
        {
          pedidos.length > 0 && (
            <div className='only-image'>
              <span className='pedidos'>
                {pedidos[indicePedido]}
              </span>
            </div>
          )
        }
      </div>

      <div className="modal fade" id="videoSourceModal" tabIndex="-1" aria-labelledby="exampleModalLabel" aria-hidden="true">
        <div className="modal-dialog">
          <div className="modal-content">
            <div className="modal-body">
              <h3>Comenzar</h3>

            </div>
            <div className="modal-footer">
              <button onClick={() => {comenzar(); cerrarModal()}} className='btn btn-primary' type='button'>Comenzar</button>
              <button type="button" onClick={() => {setEsTest(true); cerrarModal()}} className="btn btn-success" >Comenzar Test</button>
              <button type="button" className="btn btn-secondary" ref={closeRef} data-bs-dismiss="modal">Cerrar</button>
            </div>
          </div>
        </div>
      </div>
    </div>
  );
};

export default MultimediaPublicoImageBG;